import { render, staticRenderFns } from "./specialProcess.vue?vue&type=template&id=c5081906&scoped=true"
import script from "./specialProcess.vue?vue&type=script&lang=js"
export * from "./specialProcess.vue?vue&type=script&lang=js"
import style0 from "./specialProcess.vue?vue&type=style&index=0&id=c5081906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5081906",
  null
  
)

export default component.exports